import { steps } from "@/mocks/home";

export default function Guide() {
  return (
    <section id="guide" className="w-full py-16 md:py-24 bg-primary-950">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 text-xs md:text-sm font-medium text-primary-300">
            <i className="ri-route-line"></i>
            观看指南
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-background-50">
            四步完成一次顺畅的观看
          </h2>
          <p className="mt-4 text-sm md:text-base text-background-100/80 leading-relaxed">
            从找到片源到离线保存，流程本身并不复杂。按下面的顺序操作，基本不会遇到卡顿或找不到进度的情况。
          </p>
        </div>

        <ol className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {steps.map((step) => (
            <li
              key={step.id}
              className="rounded-lg border border-background-50/15 bg-background-50/5 p-6"
            >
              <span className="font-heading text-3xl font-bold text-primary-400">
                {step.index}
              </span>
              <h3 className="mt-3 font-heading text-lg font-bold text-background-50">
                {step.title}
              </h3>
              <p className="mt-2 text-sm text-background-100/75 leading-relaxed">{step.desc}</p>
            </li>
          ))}
        </ol>

        <div className="mt-8 rounded-lg border border-primary-400/30 bg-primary-900/40 p-5 md:p-6 flex flex-col sm:flex-row sm:items-center gap-4">
          <span className="w-11 h-11 flex items-center justify-center rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 shrink-0">
            <i className="ri-lightbulb-line text-xl"></i>
          </span>
          <p className="text-sm text-background-100/85 leading-relaxed">
            小提示：同一部作品通常会提供多条播放线路。如果某一条出现加载缓慢，切换另一条线路往往就能恢复流畅，
            缓存进度与观看记录不会因此丢失。
          </p>
        </div>
      </div>
    </section>
  );
}